import { render } from "./CarrouselOurJob.vue?vue&type=template&id=1af6cdc9&scoped=true&lang=html"
import script from "./CarrouselOurJob.vue?vue&type=script&lang=js"
export * from "./CarrouselOurJob.vue?vue&type=script&lang=js"

import "./CarrouselOurJob.vue?vue&type=style&index=0&id=1af6cdc9&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1af6cdc9"]])

export default __exports__